import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import Markdown from 'markdown-to-jsx'

import { request, reportErrorToHoneybadger } from '../helpers/Requests'

import SetTitle from '../components/shared/SetTitle';
import TypeOfPersonSelect from '../components/shared/TypeOfPersonSelect';
import RadialMenu from '../components/shared/RadialMenu';
import HelpText from '../components/help/HelpText';

import { adminUser, setIdAndMethod, renderErrorWarning, renderErrors } from '../utilities/Forms.js'
import Audits from '../components/shared/Audits';

class MassMailForm extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleFileUpload = this.handleFileUpload.bind(this);
    this.handleMultiCheckbox = this.handleMultiCheckbox.bind(this);
    this.insertVariable = this.insertVariable.bind(this);
    this.insertImage = this.insertImage.bind(this);
    this.handleCalculatePeople = this.handleCalculatePeople.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSend = this.handleSend.bind(this);
    this.setPreviewImageSources = this.setPreviewImageSources.bind(this);

    this.textareaRef = React.createRef();
  }

  state = {
    subject: "",
    body: "",
    images: [],
    type_of_person: "",
    location_id: "",
    person_query_type: "",
    person_query_term: "",
    person_ids: "",
    sent_at: "",

    upload_images: [],
    imageLookup: {},

    locationsLoaded: false,
    unauthorized: "",
    errors: "",
    error: ""
  };

  static variables = {
    organisation_name: localStorage.organisationName,
    person_name: "John Smith",
    location_name: "<replaced by this.state.location_name>"
  }

  allowed_variables() {
    const permanentVariables = ["organisation_name", "person_name"]
    if (this.state.location_id) {
      permanentVariables.push("location_name")
    }

    return permanentVariables
  }

  handleChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({[name]: value});
  }

  handleFileUpload(event) {
    let name = event.target.name;
    let files = event.target.files;
    let _this = this;

    for (let i = 0; i < files.length; i++) {
      if (this.state.imageLookup[files[i].name]) {
        continue;
      }

      var reader = new FileReader();

      reader.onload = function (e) {
        _this.setState(prevState => {
          let newImageLookup = {...prevState.imageLookup}
          newImageLookup[files[i].name] = e.target.result
          return {
            imageLookup: newImageLookup
          }
        })
      };

      reader.readAsDataURL(files[i]);
    }

    this.setState(prevState => {
      return {
        [name]: files,
        markdownKey: Math.random()
      }
    });
  }

  handleMultiCheckbox(event) {
    let name = parseInt(event.target.name);
    let value = event.target.checked;

    var person_ids = this.state.person_ids

    if (value === true) {
      if (!person_ids.includes(name)) {
        person_ids.push(name)
      }
    }
    else if (value === false) {
      if (person_ids.includes(name)) {
        let index = person_ids.indexOf(name)
        person_ids.splice(index, 1)
      }
    }

    this.setState({person_ids: person_ids});
  }

  insertVariable(event) {
    const variable = `{{${event.target.getAttribute("name")}}}`;
    this.insertText(variable)
  };

  insertImage(event) {
    const image = `![Alt text](${event.target.getAttribute("name")})`;
    this.insertText(image)
  };

  insertText(text) {
    const textarea = this.textareaRef.current;

    const start = textarea.selectionStart
    const end = textarea.selectionEnd
    let body = textarea.value

    if (start && end) {
      const insertSpace = textarea.value.slice(end).charAt(0) === " " ? "" : " "

      this.setState({
        body: body.slice(0, start) + text + insertSpace + body.slice(end)
      })
    }
    else {
      this.setState({
        body: body + "\n" + text
      })
    }
  }

  handleCalculatePeople(event) {
    this.setState({ updating: true })

    const { type_of_person, location_id } = this.state;
    const [person_query_type, person_query_term] = this.person_query_params()

    var params = `user_mass_mail[type_of_person]=${type_of_person}&user_mass_mail[location_id]=${location_id}&user_mass_mail[person_query_type]=${person_query_type}&user_mass_mail[person_query_term]=${person_query_term}`
    request("GET", `/v1/a/user_mass_mails/calculate_person_ids?${params}`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({ person_ids: data.person_ids, updating: false, latestQuery: "calculate_person_ids" })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        if (error instanceof Error) {
          this.setState({ updating: false, error: error, latestQuery: "calculate_person_ids" })
        }
        else {
          this.setState({ updating: false, errors: error, latestQuery: "calculate_person_ids" })
        }
      })

    event.preventDefault();
  }

  person_query_params() {
    const { person_query_type, person_query_term } = this.state;

    if (person_query_type === "never") {
      return ["last_login_before", "never"]
    }

    if (person_query_type === "everyone") {
      return ["last_login_after", "1970/01/01 00:00;true"]
    }

    return [person_query_type, person_query_term]
  }

  person_query_state(person_query_type, person_query_term) {
    if (person_query_term === "never") {
      return ["never", ""]
    }

    if (person_query_type === "last_login_after" && person_query_term === "1970/01/01 00:00;true") {
      return ["everyone", ""]
    }

    return [person_query_type, person_query_term]
  }

  handleSubmit(event) {
    event.preventDefault();

    this.setState({ updating: true })

    const [person_query_type, person_query_term] = this.person_query_params()

    let fileFieldNames = [];
    const formData = new FormData()
    formData.append('user_mass_mail[subject]', this.state.subject)
    formData.append('user_mass_mail[body]', this.state.body)
    formData.append('user_mass_mail[type_of_person]', this.state.type_of_person)
    formData.append('user_mass_mail[location_id]', this.state.location_id)
    formData.append('user_mass_mail[person_query_type]', person_query_type)
    formData.append('user_mass_mail[person_query_term]', person_query_term)

    for (let image of this.state.upload_images) {
      formData.append('user_mass_mail[images][]', image)
      fileFieldNames.push('user_mass_mail[images][]')
    }

    for (let person_id of this.state.person_ids) {
      formData.append('user_mass_mail[person_ids][]', person_id)
    }

    const [id, method] = setIdAndMethod(this.props.mode, this.props.id)

    return (
      request(method, `/v1/a/user_mass_mails/${id}`, formData, () => {this.setState({ unauthorized: true })}, fileFieldNames)
        .then(data => {
          sessionStorage.setItem("updateSuccess", `Mass Mail ${this.props.mode}d successfully!`);

          if (this.props.mode === "create") {
            this.setState({ id: data.id, redirect: true, latestQuery: "" })
          }
          else if (this.props.mode === "update") {
            this.setState({
              images: data.images,
              upload_images: [],
              imageLookup: {},
              updating: false,
              latestQuery: "",
              auditKey: Math.random()
            })

            this.props.popupCallback()
          }
          return true
        })
        .catch(error => {
          reportErrorToHoneybadger(error)

          if (error instanceof Error) {
            this.setState({ updating: false, error: error, latestQuery: "" })
          }
          else {
            this.setState({ updating: false, errors: error, latestQuery: "" })
          }
          return false
        })
    )
  }

  handleSend(event) {
    this.handleSubmit(event).then(result => {
      if (result === true) {
        this.setState({ updating: true })
        const id = this.props.id

        request("POST", `/v1/a/user_mass_mails/${id}/send_mail`, null, () => {this.setState({ unauthorized: true })})
          .then(data => {
            sessionStorage.setItem("updateSuccess", `Mass Mail will be sent out shortly.`);
            this.setState({ sent_at: data.sent_at })
            this.props.popupCallback()
          })
          .catch(error => {
            reportErrorToHoneybadger(error)

            if (error instanceof Error) {
              this.setState({ updating: false, error: error })
            }
            else {
              if (error.result === false) {
                error = { sent_at: "This Mass Mail could not be sent" }
              }

              this.setState({ updating: false, errors: error })
            }
          })
      }
    })

    event.preventDefault();
  }

  renderSentAtOrButtons() {
    if (this.state.sent_at) {
      return <div className="row">This Mass Mail was sent at {this.state.sent_at} to {this.state.person_ids.length} people.</div>
    }

    return (
      <>
        { this.renderSaveButton() }
        { this.renderSendButton() }
      </>
    )
  }

  renderSaveButton() {
    if (adminUser()) {
      return <input type="submit" value="Save" disabled={this.state.updating} onClick={this.handleSubmit} />
    }
    else {
      return <input type="submit" value="Sorry, you don't have permission to save changes" disabled="disabled" />
    }
  }

  renderSendButton() {
    if (this.props.mode === "create" || !adminUser()) {
      return null
    }

    return (
      <>
        <input type="submit" value=" Save and Send" disabled={this.state.updating} onClick={this.handleSend} />
        {renderErrors(this.state.errors, 'sent_at')}
      </>
    )
  }

  replaceVariables(body, allowed_variables) {
    allowed_variables.forEach((variable) => {
      const pattern = new RegExp(`{{${variable}}}`, 'g');
      let string = MassMailForm.variables[variable]

      if (variable === "location_name") {
        string = this.state.locations.find(location => location.id.toString() === this.state.location_id.toString()).name
      }

      body = body.replace(pattern, string);
    })

    return body
  }

  render() {
    const { subject, body, images, type_of_person, location_id, person_query_type, person_query_term, person_ids, sent_at, markdownKey, latestQuery, locations, loaded, locationsLoaded, auditKey, id, redirect, unauthorized, errors, error } = this.state;

    if (this.state.loggedIn) {
      return <Redirect to="/"/>
    }

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (redirect && id) {
      return <Redirect to={`/mass-mails/${id}`}/>
    }

    if (loaded === false || locationsLoaded === false) {
      return <p>Loading ...</p>;
    }

    const title = this.props.mode === "create" ? "New" : sent_at ? "View" : "Edit"
    const formatSubject = subject ? ` ${subject} |` : ""

    const upload_images = [...this.state.upload_images]

    return (
      <div>
        <SetTitle title={`${title} Mass Mail |${formatSubject} Mass Mails`} />

        <form onSubmit={this.handleSubmit}>
          <div className="settings big-settings top-padding email-template-page">
            <div className="button small-button float-right negative-right-margin negative-top-margin" onClick={this.props.handleBack}>Back</div>

            <div className="row">
              <HelpText page={'mass_mail'} section={'subject'} />

              <label className="column">Subject:</label>{ renderErrors(errors, 'subject') }
              <input className="column" type="text" name="subject" value={subject} onChange={this.handleChange} />
            </div>

            <div className="row">
              <HelpText page={'mass_mail'} section={"type_of_person"} />

              <label className="column">Sent to type of person:</label>{ renderErrors(errors, 'type_of_person') }
              <TypeOfPersonSelect value={type_of_person} onChange={this.handleChange} />
            </div>

            <div className="row">
              <HelpText page={'mass_mail'} section={'location'} />

              <label className="column">Location (optional):</label>{ renderErrors(errors, 'location_id') }
              <select name="location_id" onChange={this.handleChange} value={location_id}>
                <option value="">Select</option>
                {locations.map((location) => (
                  <option value={location.id} key={location.id}>{location.name}</option>
                ))}
              </select>
            </div>

            <div className="row">
              <HelpText page={'mass_mail'} section={'person_query_type'} />

              <label className="column">Sent to people with:</label>{ renderErrors(errors, 'person_query_type') }
              <RadialMenu options={["last_login_before", "last_login_after", "never", "everyone"]} override={["Last Event Before", "Last Event After", "No Events"]} name={"person_query_type"} state={person_query_type} onChange={this.handleChange} />
            </div>

            {!["never", "everyone"].includes(person_query_type) &&
              <div className="row">
                <HelpText page={'mass_mail'} section={'latest_event_date'} />

                <label className="column">Latest Event Date:</label>{ renderErrors(errors, 'person_query_term') }
                <input className="column" type="datetime-local" name="person_query_term" value={person_query_term} onChange={this.handleChange} />
              </div>
            }

            { person_ids && <div className="small-bottom-margin">This Mass Mail would be sent to {person_ids.length} {person_ids.length === 1 ? "person" : "people"}.</div> }
            { !sent_at &&
              <>
                <input type="submit" value={`${person_ids ? "Recalculate" : "Calculate"} recipients`} disabled={this.state.updating} onClick={this.handleCalculatePeople} />
                { latestQuery === "calculate_person_ids" && renderErrorWarning(errors) }
              </>
            }

            <div className="row email-body">
              <div>
                <HelpText page={'mass_mail'} section={'body'} className="margin-right" />
                <label className="column">Body:</label>{ renderErrors(errors, 'body') }

                <textarea className="mass-mail-body" name="body" value={body} onChange={this.handleChange} ref={this.textareaRef} />
              </div>
              <div>
                <HelpText page={'mass_mail'} section={'preview'} />
                <label className="column">Preview:</label>

                <div className="email-preview" key={markdownKey}><Markdown options={{ disableParsingRawHTML: true, disableAutoLink: true }} children={this.replaceVariables(body, this.allowed_variables())} /></div>
              </div>

              <div className="small-top-padding">
                <HelpText page={'mass_mail'} section={'variables'} className="margin-right" />
                <label className="column">Variables:</label>

                <div className="variables">
                  {this.allowed_variables().map((variable) => (
                    <div className="tooltip-container" key={variable}>
                      <div className="variable-button tooltip-trigger" name={variable} onClick={this.insertVariable}>{variable}</div>
                      <span className="tooltip below"><Markdown children={this.replaceVariables(`{{${variable}}}`, [variable])} /></span>
                    </div>
                  ))}
                </div>
              </div>

              <div/>

              <div className="small-top-padding">
                <HelpText page={'mass_mail'} section={'images'} className="margin-right" />
                <label className="column">Images:</label>{ renderErrors(errors, 'images') }

                <div className="variables">
                  {images.map((image) => (
                    <div className="tooltip-container" key={image.name}>
                      <div className="variable-button tooltip-trigger" name={image.name} onClick={this.insertImage}>{image.name}</div>
                      <span className="tooltip below"><img className="tooltip-image" src={`${process.env.REACT_APP_ROOT_DOMAIN}/${image.url}`} alt={image.name} /></span>
                    </div>
                  ))}
                  {upload_images.map((image) => (
                    <div className="tooltip-container" key={image.name}>
                      <div className="variable-button tooltip-trigger" name={image.name} onClick={this.insertImage}>{image.name}</div>
                      <span className="tooltip below"><img className="tooltip-image" src={this.state.imageLookup[image.name]} alt={image.name} /></span>
                    </div>
                  ))}
                </div>

                <input className="column" type="file" name="upload_images" onChange={this.handleFileUpload} accept="image/*" multiple />
              </div>

            </div>
          </div>

          <div className="settings big-settings top-padding email-template-page">
            {this.renderSentAtOrButtons()}
            { latestQuery !== "calculate_person_ids" && renderErrorWarning(errors) }
          </div>
        </form>

        { this.props.mode === "update" && <Audits key={auditKey} className="settings big-settings top-padding email-template-page" klass="UserMassMail" id={this.props.id} /> }
      </div>
    );
  }

  setPreviewImageSources() {
    const fileNames = [...this.state.upload_images].map(upload_image => upload_image.name)

    document.querySelectorAll(".email-preview img").forEach(image => {
      // root domain, e.g. app.dereception.com + /mass-mails/
      let source = image.src.slice(document.location.origin.length + 12)
      if (image.title) {
        source += ` ${image.title}`
      }

      if (fileNames.includes(source) && this.state.imageLookup[source]) {
        image.src = this.state.imageLookup[source]
        return
      }

      let savedImage = this.state.images.find(image => image.name === source)
      if (savedImage) {
        image.src = `${process.env.REACT_APP_ROOT_DOMAIN}/${savedImage.url}`
      }
    })
  }

  schedulePreviewImageSourcing() {
    // Store a 'this' ref, and
    var _this = this;
    // wait for a paint before injecting locally stored images
    window.requestAnimationFrame(function() {
      _this.setPreviewImageSources()
    });
  }

  componentDidUpdate() {
    this.schedulePreviewImageSourcing()
  }

  componentDidMount() {
    let id = this.props.id;

    if (this.props.mode === "create") {
      this.setState({ loaded: true })
    }
    else {
      request('GET', `/v1/a/user_mass_mails/${id}`, null, () => {this.setState({ unauthorized: true })})
        .then(data => {

          let [person_query_type, person_query_term] = this.person_query_state(data.person_query_type, data.person_query_term)

          this.setState({
            subject: data.subject,
            body: data.body,
            images: data.images,
            type_of_person: data.type_of_person,
            location_id: data.location_id || "",
            person_query_type: person_query_type,
            person_query_term: person_query_term,
            person_ids: data.person_ids,
            sent_at: data.sent_at,
            loaded: true
          })

          this.props.updateSentAt(data.sent_at)
        })
        .catch(error => {
          reportErrorToHoneybadger(error)

          this.setState({ error, loaded: true })
        })
    }

    request('GET', `/v1/a/locations/names_and_ids`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({ locations: data, locationsLoaded: true })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, locationsLoaded: true })
      })
  }
}

export default MassMailForm;
